import { render, staticRenderFns } from "./SubmitNicModal.vue?vue&type=template&id=5a7bd001&scoped=true&"
import script from "./SubmitNicModal.vue?vue&type=script&lang=js&"
export * from "./SubmitNicModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmitNicModal.vue?vue&type=style&index=0&id=5a7bd001&prod&scoped=true&lang=css&"
import style1 from "./SubmitNicModal.vue?vue&type=style&index=1&id=5a7bd001&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7bd001",
  null
  
)

export default component.exports